import React from 'react';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import { Page } from './common/styles';
import Header from './common/header';
import SiteMap from './common/site-map';
import Footer from './common/footer';
import Content from './livewire-general-terms-elements/content';

export default function LivewireGeneralTerms(props) {
  const common = commonProps();
  const state = {
    ...props,
    ...common,
    light: true,
  };

  return (
    <ThemeProvider theme={state}>
      <Page>
        <Header />
        <Content />
        <SiteMap />
        <Footer />
      </Page>
    </ThemeProvider>
  );
}
